import { html, LitElement } from 'lit-element';
import { cellStyles } from '../cssUtils.js';

/**
 * @element charting-cell
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-cell-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-cell-width - change the width (must be valid, eg: 100px, 10em )
 */
export class ChartingCell extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${cellStyles}
      </style>
      <div class="cell"></div>`;
  }
}

export default ChartingCell;
